
import { PackageType } from '../models/packageType';

export interface IPackageTypeService {
    getPackageTypes(): Promise<Array<PackageType>>;
}

export class PackageTypeService implements IPackageTypeService {
    static $inject = ['$http'];

    constructor(private _$http: angular.IHttpService) {

    }

    getPackageTypes(): Promise<any> {

        return new Promise<PackageType[]>((resolve, reject) => {
            this._$http.get('/getPackageTypes')
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                    const packageTypes = response.data.map(s => new PackageType(s.packageTypeId, s.description));
                    resolve(packageTypes);
                });
        });
    }


}

angular.module('deliveryCreate.app').service('packageTypeService', PackageTypeService);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/packageDialog/services/packageTypeService.ts
 **/